import React from 'react'
import { Link } from '@tanstack/react-router'
import { useAuth } from '@/hooks/useAuth'
import { withPageProtection } from '@/lib/rbac/hoc'
import { PAGES } from '@/lib/rbac/constants'
import { Button } from '@/components/ui/Button'
import { DepartmentForm } from '@/components/workforce/DepartmentForm'
import { ArrowLeft, Building2 } from 'lucide-react'

function NewDepartmentContent() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Link to="/workforce/departments">
          <Button variant="ghost" size="sm">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar
          </Button>
        </Link>
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold text-white flex items-center gap-3">
            <Building2 className="w-8 h-8 text-brand-primary" />
            Novo Departamento
          </h1>
          <p className="font-body text-brand-gray mt-2">
            Crie um novo departamento para organizar sua estrutura organizacional
          </p>
        </div>
      </div>

      {/* Form */}
      <DepartmentForm mode="create" />
    </div>
  )
}

// Apply RBAC protection
export default withPageProtection(NewDepartmentContent, PAGES.WORKFORCE_DEPARTMENTS)
